import { render, staticRenderFns } from "./Prize_shop_item.vue?vue&type=template&id=d636909c"
import script from "./Prize_shop_item.vue?vue&type=script&lang=js"
export * from "./Prize_shop_item.vue?vue&type=script&lang=js"
import style0 from "./Prize_shop_item.vue?vue&type=style&index=0&id=d636909c&prod&scope=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports